var render, staticRenderFns
import script from "./buildinglist.vue?vue&type=script&lang=js&"
export * from "./buildinglist.vue?vue&type=script&lang=js&"
import style0 from "./buildinglist.vue?vue&type=style&index=0&id=6cfa91fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfa91fc",
  null
  
)

export default component.exports